import type { ChatRoom } from 'models';
import { isGroupChatroom, isMessagePlaceholder } from 'models';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useUser } from 'features/auth';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- Break circular dependencies
import { useGetUserFullNameWithFallback } from 'features/users/hooks';

type P = Pick<ChatRoom, 'message' | 'participants' | 'tags'>;

export const useGetChatroomLastMessageAuthor = () => {
  const { nodeUserData: nodeViewer } = useUser();
  const getUserFullNameWithFallback = useGetUserFullNameWithFallback();
  const { t } = useTranslation();

  return useCallback(
    ({ message, participants, tags }: P) => {
      if (!message) {
        return undefined;
      }

      if (isMessagePlaceholder(message) || message.author === nodeViewer._id) {
        return t('You');
      }

      if (!isGroupChatroom({ chatroom: { tags } }) || !message.author) {
        return undefined;
      }

      return getUserFullNameWithFallback(participants[message.author] ?? {});
    },
    [getUserFullNameWithFallback, nodeViewer._id, t],
  );
};
